import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useRecoilValue } from 'recoil';
import ConsumablesConfigSelector from '../../../recoil/cashout/ConsumablesConfigSelector';
import { getProductThumbnailUrl } from '../../helpers/AssetUtils';
import Gift from '../../icons/Gift';

/* Falls back to the generic gift icon when the product carries no thumbnail, when the
 * asset host is not configured, or when the image fails to load - the product name
 * beside it already identifies the item, so a missing image must not break the row.
 */
export default function ItemConvertThumbnail({ product }) {
  const config = useRecoilValue(ConsumablesConfigSelector);
  const {
    consumables: {
      assetsBaseUrl,
    } = {},
  } = config || {};

  const [hasFailed, setHasFailed] = useState(false);

  const url = getProductThumbnailUrl(product, assetsBaseUrl);

  if (!url || hasFailed) {
    return <Gift />;
  }

  return (
    <img
      className="to-item-convert-thumbnail"
      src={url}
      alt=""
      onError={() => setHasFailed(true)}
    />
  );
}

ItemConvertThumbnail.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  product: PropTypes.object.isRequired,
};
